import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { MedicalReimbursement } from '../../../../database/tables'
import { FetchStatus } from '../../../../types/fetch-status.types'
import constants from '../../../../constants'
import * as dateFns from 'date-fns'
import MedicalReimbursementService from '../../../../services/medical-reimbursement'
import adminMedicalReimbursementApprovalPopupStore from '../../../../store/adminMedicalReimbursementApprovalPopupStore'
import { ApprovalStatus } from '../../../../database/enums/ApprovalStatus.enum'
import authStore from '../../../../store/authStore'
import PERMISSIONS from '../../../../private/permissions'
import toast from 'react-hot-toast'

export default function useAdminMedicalReimbursementDetailViewModel() {
  const params = useParams()
  const id = params.id as string | null
  const user = authStore(state => state.user)

  const [dataFetchStatus, setDataFetchStatus] = useState<FetchStatus>(constants.fetchStatus.default)
  const [detailData, setDetailData] = useState<MedicalReimbursement | null>(null)

  const canApproval = useCallback(() => {
    if (!!user && !!user.email) return PERMISSIONS.getApprovalEmails().includes(user.email)
    return false
  }, [user])()

  async function fetchDetailData() {
    if (!!id) {
      setDataFetchStatus({ ...constants.fetchStatus.default, isLoading: true })
      await MedicalReimbursementService.getById({ id })
        .then(res => {
          setDataFetchStatus({ ...constants.fetchStatus.default, isSuccess: true })
          setDetailData(res)
        })
        .catch(error => {
          console.log(error)
          setDataFetchStatus({ ...constants.fetchStatus.default, isError: true })
        })
    }
  }

  function getDateValue(serviceDate: Date): string {
    return dateFns.format(serviceDate, constants.dateFormats.basicReadable)
  }

  function onApproveClick() {
    if (canApproval)
      adminMedicalReimbursementApprovalPopupStore.setState({
        approvalStatus: ApprovalStatus.APPROVED,
        data: detailData,
        open: true,
      })
    else toast.error("You don't have permission to do this action!")
  }

  function onRejectClick() {
    if (canApproval)
      adminMedicalReimbursementApprovalPopupStore.setState({
        approvalStatus: ApprovalStatus.REJECTED,
        data: detailData,
        open: true,
      })
    else toast.error("You don't have permission to do this action!")
  }

  function onApprovalPopupConfirm() {
    fetchDetailData()
  }

  useEffect(() => {
    fetchDetailData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return {
    id,
    detailData,
    dataFetchStatus,
    canApproval,
    getDateValue,
    onApproveClick,
    onRejectClick,
    onApprovalPopupConfirm,
  }
}
